import { useAtom } from "jotai";
import { useCallback } from "react";
import useIsMobile from "../../../../../hooks/device/useIsMobile";
import { NO_SCROLL_BODY_CLASS } from "../../../Header/Search/search-input-mobile";
import { trackChatbotPanelOpened } from "../../events/chatbot-panel-opened-event";
import { chatbotOpenAtom } from "../../stores/chatbot.store";

export function useChatbotPanel() {
  const isMobile = useIsMobile();
  const [isChatbotOpen, setIsChatbotOpen] = useAtom(chatbotOpenAtom);

  const closeChatbotPanel = useCallback(
    function closeChatbotPanel() {
      if (isMobile) {
        document.body.classList.remove(NO_SCROLL_BODY_CLASS);
      }
      setIsChatbotOpen(false);
    },
    [isMobile, setIsChatbotOpen]
  );

  const openChatbotPanel = useCallback(
    function openChatbotPanel() {
      if (isChatbotOpen) {
        return;
      }

      if (isMobile) {
        document.body.classList.add(NO_SCROLL_BODY_CLASS);
      }
      setIsChatbotOpen(true);
      trackChatbotPanelOpened();
    },
    [isMobile, setIsChatbotOpen, isChatbotOpen]
  );

  return {
    isChatbotOpen,
    closeChatbotPanel,
    openChatbotPanel,
  };
}
